import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { CourseDetailEntity } from 'src/entities/Course.entity';

import { IdOption, courseLabel, withCurrentOption } from './courseMasterUtils';

type Props = { open: boolean; course: CourseDetailEntity; trucks: IdOption[]; onConfirm: (truckId: number | null) => void; onClose: () => void };

/**
 * ダイヤに入っている 2 便を 1 便に戻すとき、元の 1 便と同じ車両のままだと同じダイヤで同じトラックになり 422（API 仕様「便区分と一緒に通常車両を変える」）。
 * 車両だけ先に変えても便グループ全体に伝播して解けないので、独立後の車両を選んで trip_no と一緒に送る（判断事項 13）
 */
export default function UnlinkTripDialog({ open, course, trucks, onConfirm, onClose }: Props) {
  const [truckId, setTruckId] = useState<number | ''>('');
  const options = withCurrentOption(trucks, course.defaultTruck && { id: course.defaultTruck.id, label: course.defaultTruck.licensePlateValue });
  return (
    // Why not 親で key を変える: 開くたびの番号を CourseDetail に持たせることになる。閉じ終わりで戻せばこのダイアログだけで済む
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      slotProps={{ transition: { onExited: () => setTruckId('') } }}
    >
      <DialogTitle sx={{ fontSize: 16 }}>1便として独立させます</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: '8px !important' }}>
        <Typography sx={{ fontSize: 14 }}>
          {courseLabel(course)} を {course.firstTripCourse?.code} の便グループから外します。同じダイヤで {course.firstTripCourse?.code} と同じ車両のままにはできないので、独立後の通常車両を選んでください（未設定も可）。
        </Typography>
        <TextField select size="small" label="独立後の通常車両" value={truckId} onChange={(e) => setTruckId(e.target.value === '' ? '' : Number(e.target.value))}>
          <MenuItem value="">未設定</MenuItem>
          {options.map((o) => <MenuItem key={o.id} value={o.id}>{o.label}</MenuItem>)}
        </TextField>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button variant="contained" disableElevation onClick={() => onConfirm(truckId === '' ? null : truckId)}>1便にする</Button>
      </DialogActions>
    </Dialog>
  );
}
